import Util from 'core/js/util'
import Const from 'core/js/const'
import i18n from '../../src/locales';

function timeFormat(timestamp, format) {
    if (!timestamp) {
        return '-';
    }

    if (!format) {
        format = 'Y-m-d H:i:s';
    }
    return Util.timeFormat(timestamp, format);
}

function showImg(img) {
    if (!img) {
        return '/default-avatar-blue.jpg'
    }
    if (img.indexOf('http') >= 0) {
        return img;
    }
    return Const.NET.IMG_URL_PREFIX + img;
}
function showDisableType(type) {
    let obj = Const.DISABLE_TYPE;
    switch (type) {
        case obj.OPEN:
            return '禁用'
            break;
        case obj.CLOSE:
            return '启用';
            break;

        default:
            break;
    }
}
function showPlatForm(value) {
    let platformList = Const.PLATFORM_LIST;
    let item = platformList.find(plat => plat.value == value);
    if(item) {
        return item.label
    }else {
        return '未知平台'
    }
}
function showMessageType(type) {
    let obj = Const.MESSAGE_TYPE;
    switch (type) {
        case obj.AUTH:
            return '授权'
            break;
        case obj.DEVICE_EXCEPTION:
            return '设备异常';
            break;
        case obj.OFFICIAL:
            return '官方推送';
            break;
        case obj.MOVE:
            return '移动报警';
            break;
        case obj.LOW_POWER:
            return '电量低';
            break;
        case obj.SOS:
            return 'SOS';
            break;
        case obj.CIRCLE_IN:
            return '电子围墙';
            break;
        case obj.CIRCLE_OUT:
            return '电子围墙';
            break;
        case obj.NO_POSITION:
            return '未获取定位数据';
            break;
        case obj.COMMEND:
            return '待下发指令';
            break;
        default:
            break;
    }
}
function eightNumber(num) {
    let str = num.toString();
    let newStr = str.substring(0,9);
    return Number(newStr);
}
function showBindStatus(status) {

    let num = Number(status);
    if(Number.isNaN(num)) {
        return status
    }
    switch (num) {
        case Const.BIND_STATUS.BIND:
            return '绑定'
            break;
        case Const.BIND_STATUS.UNBIND:
            return '解绑'
            break;
        default:
            break;
    }
    let newStr = str.substring(0,9);
    return Number(newStr);
}

function showModeType(type,isDisplay) {

    let num = Number(type);
    if(Number.isNaN(num)) {
        return type
    }
    let normal = ['智能模式','配置模式','资产检测模式','周模式','访客模式','配置模式'];
    let display = ['智能','GPS配置','资产检测','周','访客','基站配置'];
    switch (num) {
        case Const.MODE_TYPE.INTE:
            return isDisplay?display[0]:normal[0]
            break;
        case Const.MODE_TYPE.SETTING:
            return isDisplay?display[1]:normal[1]
            break;
        case Const.MODE_TYPE.FUND:
            return isDisplay?display[2]:normal[2]
            break;
        case Const.MODE_TYPE.WEEK:
            return isDisplay?display[3]:normal[3]
            break;
        case Const.MODE_TYPE.VISIT:
        return isDisplay?display[4]:normal[4]
            break;
        case Const.MODE_TYPE.NEW_SETTING:
        return isDisplay?display[5]:normal[5]
            break;
        default:
            return '--'
            break;
    }
}
function showDeviceStatus(status) {

    let num = Number(status);
    if(Number.isNaN(num)) {
        return '未知'
    }
    switch (num) {
        case 1:
            return '在线'
            break;
        case 0:
            return '关机'
            break;
        default:
            return '未知'
            break;
    }
}

function deviceType(value) {
    for (var i = 0 ; Const.deviceType.length > i ; i++){
        if (Const.deviceType[i].value === value){
            return Const.deviceType[i].label
        }
    }
}
function parseLogType(value) {
    // value = parseInt(value)
    let num = Number(value);
    if(Number.isNaN(num)) {
        return '未知'
    }
	let lang = localStorage.getItem ('skf.data.lang')
	if (lang == '"en"') {
		switch (num) {
			case 1:
				return 'Device Management';
				break;
			case 2:
				return 'Provider Management'
				break;
			case 3:
				return 'Privilege Management'
				break;
			default:
				return 'Unknown'
		}
	} else {
		switch (num) {
			case 1:
				return '设备管理';
				break;
			case 2:
				return '服务商管理'
				break;
			case 3:
				return '权限管理'
				break;
			default:
				return '未知'
		}
	}

}

function filterErrorType(val) {
    let arr = []
	val = val.split(',')
    val.forEach((item)=>{
    if(item.length){
	    let num = parseInt(item)
	    let lang = localStorage.getItem ('skf.data.lang')
	    if (num >0 && num <= 7){
            let prefix = 'devicePage.errorDetail.'
			    switch (num) {
				    case 1: arr.push(i18n.t(prefix + 'lubricator_empty'))
					    break;
				    case 2: arr.push(i18n.t(prefix + 'low_battery'))
					    break;
				    case 3: arr.push(i18n.t(prefix + 'dead_battery'))
					    break;
				    case 4: arr.push(i18n.t(prefix + 'high_pressure_warning'))
					    break;
				    case 5: arr.push(i18n.t(prefix + 'high_voltage_alarm'))
					    break;
				    case 6: arr.push(i18n.t(prefix + 'internal_error'))
					    break;
				    case 7: arr.push(i18n.t(prefix + 'lubricator_will_be_empty'))
					    break;
			    }
	    } else {
		    console.log('错误详情返回错误，值：', num)
	    }
    }


    })

    return arr.join(', \r\n\r')
}

const _filters = {
    timeFormat,
    showImg,
    showDisableType,
    showMessageType,
    eightNumber,
    showBindStatus,
    showModeType,
    showDeviceStatus,
    showPlatForm,
    filterErrorType,
    parseLogType,
    deviceType
};

export default (Vue) => {
    Object.keys(_filters).forEach(key => {
        Vue.filter(key, _filters[key])
    })
}
